import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useCallback } from 'react';

export const useHttpErrorHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errorStatus, setErrorStatus] = useState(null); // caller decides what to do

  const handleExpiredToken = useCallback(() => {
    console.log('Expired session token, redirecting to login.');
    localStorage.removeItem('token');
    navigate('/login', { state: { from: location } });
  }, [navigate, location]);

  const httpErrorHandler = useCallback(
    (err) => {
      const status = err?.response?.status;
      setErrorStatus(status);
      console.log(err);

      if (status === 401) {
        handleExpiredToken();
      } else if (status === 404) {
        alert('404: The requested resource could not be found.');
      } else {
        console.error('Unexpected error:', err);
      }
    }, [handleExpiredToken]
  );

  return { httpErrorHandler, errorStatus };
};
